import { UPDATE_HAS_MESSAGES } from '../actions';

export function hasMessages(state = false, action) {
  switch (action.type) {
    case UPDATE_HAS_MESSAGES: {
      return action.hasMessages;
    }
    default:
      return state;
  }
}
